import { cafeteriaBoutique } from '../../../mocks/cafeteria-boutique';

export default function CafeteriaSection() {
  const handleWhatsAppClick = () => {
    const mensaje = encodeURIComponent('Hola, me gustaría consultar los horarios de la cafetería');
    window.open(`https://wa.me/56994347092?text=${mensaje}`, '_blank');
  };

  return (
    <section id="cafeteria" className="py-20 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Título */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nuestra Historia
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            {cafeteriaBoutique.descripcion}
          </p>
        </div>

        {/* Grid de beneficios */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {cafeteriaBoutique.beneficios.map((beneficio, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-8 text-center hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-amber-600 to-orange-700 rounded-full flex items-center justify-center">
                <i className={`${beneficio.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {beneficio.titulo}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {beneficio.descripcion}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <button
            onClick={handleWhatsAppClick}
            className="inline-flex items-center gap-2 md:gap-3 bg-gradient-to-r from-green-600 to-green-700 text-white px-5 py-3 md:px-8 md:py-4 rounded-full text-base md:text-lg font-semibold hover:from-green-700 hover:to-green-800 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-xl md:text-2xl"></i>
            Consultar Horarios por WhatsApp
          </button>
        </div>
      </div>
    </section>
  );
}
